import cx from 'classnames'
import s from './category-tag.module.scss'

type Props = {
  children: React.ReactNode
  className?: string
}

export const CategoryTag = ({ children, className }: Props) => {
  return <p className={cx(s.categoryTag, className)}>{children}</p>
}
